const endpoints = {
  listResources: (): string => `resource`,
  listOperations: (): string => `operation`,
};

export default endpoints;
